const botmarkerConfig = {
  UBPE: {
    src: 'https://go.botmaker.com/rest/webchat/p/21L7HW4N6L/init.js',
    matchPath: [
      { path: '/interesados', isExact: true },
      { path: '/avisos', isExact: true },
      { path: 'configuracion', isExact: false }
    ]
  },
  DVPE: {
    src: 'https://go.botmaker.com/rest/webchat/p/YJITA32E4V/init.js',
    matchPath: [
      { path: '/interesados', isExact: true },
      { path: '/avisos', isExact: true },
      { path: 'configuracion', isExact: false }
    ]
  },
  '24MX': {
    src: 'https://go.botmaker.com/rest/webchat/p/K2K03I2LLC/init.js',
    matchPath: [
      { path: '/interesados', isExact: false },
      { path: '/avisos', isExact: true },
      { path: 'configuracion', isExact: false }
    ]
  },
  CAPA: {
    src: 'https://go.botmaker.com/rest/webchat/p/508Z6N0P8S/init.js',
    matchPath: [{ path: '/interesados', isExact: false }, { path: 'configuracion', isExact: false }]
  },
  PLEC: {
    src: 'https://go.botmaker.com/rest/webchat/p/1E1Y3D4N2Y/init.js',
    matchPath: [
      { path: '/interesados', isExact: false },
      { path: '/avisos', isExact: true },
      { path: 'configuracion', isExact: false }
    ]
  },
  ZPAR: {
    src: 'https://go.botmaker.com/rest/webchat/p/M4IZNPRBU3/init.js',
    matchPath: [
      { path: '/interesados', isExact: false },
      { path: '/avisos', isExact: true },
      { path: 'configuracion', isExact: false }
    ]
  }
};
const botmakerID = 'botmarket';
let shouldInsert = false;
const insertScript = src => {
  if (shouldInsert === false) {
    const js = document.createElement('script');
    js.type = 'text/javascript';
    js.id = botmakerID;
    js.async = 1;
    // TODO: create dev url
    js.src =
      process.env.NODE_ENV === 'development' ? 'https://go.botmaker.com/rest/webchat/p/yTKcFVheUPwm/init.js' : src;
    document.body.appendChild(js);
    shouldInsert = true;
  }
};

const getBotmarkerConfigBySite = () => {
  const siteId = process.env.REACT_APP_BUILD_SITE;
  return botmarkerConfig[siteId];
};

const isMatchedPath = (matchPath, pathname) => {
  if (pathname.startsWith('/interesados/') && pathname !== '/interesados') {
    return false;
  }

  return (
    matchPath.find(p => {
      if (p.isExact) {
        return pathname === p.path;
      }
      return pathname.indexOf(p.path) !== -1;
    }) !== undefined
  );
};

const botmaker = history => {
  const config = getBotmarkerConfigBySite();
  if (config) {
    if (isMatchedPath(config.matchPath, history.location.pathname)) {
      insertScript(config.src);
    }

    history.listen(p => {
      const { pathname } = p;
      const botmarketElement = document.getElementById(botmakerID);
      const availablePath = isMatchedPath(config.matchPath, pathname);
      if (!availablePath) {
        if (botmarketElement) {
          botmarketElement.remove();
          const iframes = document.querySelectorAll('iframe');
          iframes.forEach(d => {
            if (d.getAttribute('name') === 'Botmaker') {
              const parentElement = d.parentNode;
              if (parentElement) {
                parentElement.remove();
              }
              d.parentNode.removeChild(d);
            }
          });
        }
      } else if (botmarketElement === null) {
        insertScript(config.src);
      }
    });
  }
};

export default botmaker;
